define(["data/config", "componentClasses/popover"], function(config, popover) {

    var validateEmail = function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    var apply = function($element, params) {
        $element.on("blur", function(ev) {
            if($element.data('validation') !== 'auto'){
                regex = /adyen-encrypted-form*/;
                if (!regex.test($element.attr('id'))) {
                    if (($element.val().length > 0 && !$element.hasClass("invalid") && $element.attr('type') !== 'email') || ($element.attr('type') == 'email' && validateEmail($element.val()))) {
                        $element.parent().addClass("c_uiInputWrapper--completed");
                    } else {
                        $element.parent().removeClass("c_uiInputWrapper--completed");
                    }
                }
            }
        });

        //for data-validation = auto
        $element.on('invalid', function() {
            console.log("invalid", $element);
            $element.parent().removeClass("c_uiInputWrapper--completed");
        })

        $element.on(config.events.inputError, function(ev, msg) {
            $element.addClass("c_uiInput--error");
            if (msg) {
                var $pop = new popover({
                    origin: $element,
                    position: "top",
                    style: "error",
                    html: msg,
                    persist: true
                });
                $pop.place();
            }
            $element.one("focus", function() {
                $element.removeClass("c_uiInput--error");
                if (msg) {
                    $pop.trigger(config.events.popoverRequestClose);
                }
            });
        });

        $element.on(config.events.inputSuccess, function(ev) {
            $element.parent().addClass("c_uiInputWrapper--completed");
            $element.removeClass("c_uiInput--error");
        });

        if (params.test) {
            $element.on("blur", function(ev) {
                var text = params.test;
                if (
                    $element.val().length > 0 &&
                    $element.val().match(text) === null
                ) {
                    $element.trigger(config.events.inputError);
                }
            });
        }
    };

    return {
        name: "uiInput",
        apply: apply
    };
});
